import { toNormalised } from 'postcode'
import PropTypes from 'prop-types'
import React from 'react'
import {
  Dialog,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  Typography,
  makeStyles,
} from '@material-ui/core'
import { LocationOn, ExpandMore } from '@material-ui/icons'

import { Button, SearchInput } from 'src/modules/ui'

const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: theme.palette.fadedPurple.main,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    '&:last-child': {
      marginBottom: 0,
    },
  },
  dialogContent: {
    padding: theme.spacing(2, 2, 0),
  },
  environmentList: {
    backgroundColor: 'white',
    borderRadius: theme.shape.borderRadius,
  },
  grow: {
    flexGrow: 1,
  },
  heading: {
    color: theme.palette.purple.main,
    fontWeight: 500,
    marginBottom: theme.spacing(1.5),
  },
  input: {
    backgroundColor: 'white',
  },
}))

const SupplierLocation = ({
  environment,
  environments,
  onChangePostcode,
  onChangeEnvironment,
  postcode,
}) => {
  const classes = useStyles()
  const [open, setOpen] = React.useState(false)

  const handleOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }

  const handleChangeEnvironment = environment => {
    onChangeEnvironment(environment)
    onChangePostcode('')
    handleClose()
  }
  const handleChangePostcode = postcode => {
    const formattedPostcode = toNormalised(postcode)
    onChangePostcode(formattedPostcode || postcode)
    onChangeEnvironment(null)
    handleClose()
  }
  const handleRemove = () => {
    onChangePostcode('')
    onChangeEnvironment(null)
    handleClose()
  }

  let text
  if (postcode) {
    text = `Near ${postcode}`
  } else if (environment) {
    const env = environments.find(e => e.id === environment)
    text = `Near ${env.name}`
  } else {
    text = 'Find Suppliers Near Me'
  }

  return (
    <>
      <Button
        color="primary"
        startIcon={<LocationOn />}
        endIcon={<ExpandMore />}
        onClick={handleOpen}
        size="large"
      >
        {text}
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <div className={classes.dialogContent}>
          <div className={classes.container}>
            <Typography className={classes.heading}>Near A Postcode</Typography>
            <SearchInput
              autoFocus
              inputProps={{ className: classes.input }}
              onChange={handleChangePostcode}
              size="large"
              value={postcode}
            />
          </div>
          {environments && environments.length ? (
            <div className={classes.container}>
              <Typography className={classes.heading}>
                Near Your Environments
              </Typography>
              <List className={classes.environmentList}>
                {environments.map(location => (
                  <ListItem
                    button
                    key={location.id}
                    onClick={() => handleChangeEnvironment(location.id)}
                  >
                    <ListItemText
                      primary={location.name}
                      secondary={location.postcode}
                    />
                  </ListItem>
                ))}
              </List>
            </div>
          ) : null}
        </div>
        <DialogActions>
          {environment || postcode ? (
            <Button onClick={handleRemove}>Remove Location</Button>
          ) : null}
          <div className={classes.grow} />
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

SupplierLocation.propTypes = {
  environment: PropTypes.number,
  environments: PropTypes.array,
  onChangePostcode: PropTypes.func,
  onChangeEnvironment: PropTypes.func,
  postcode: PropTypes.string,
}

export default SupplierLocation
